var _style, _rect, _line, _line2, _line3, _line4, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 32 32",
    id: "icons",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:red;stroke-width:2;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 22,
    id: "XMLID_14_",
    width: 16,
    x: 8,
    y: 7
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    id: "XMLID_4_",
    x1: 16,
    x2: 16,
    y1: 10,
    y2: 26
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    id: "XMLID_118_",
    x1: 20,
    x2: 20,
    y1: 10,
    y2: 26
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    id: "XMLID_3_",
    x1: 12,
    x2: 12,
    y1: 10,
    y2: 26
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    id: "XMLID_5_",
    x1: 5,
    x2: 27,
    y1: 7,
    y2: 7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 4,
    id: "XMLID_6_",
    width: 6,
    x: 13,
    y: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_386_"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.f8084a64ed80db27f41e57c3e50e2366.svg";
export { ForwardRef as ReactComponent };